module.exports = __webpack_public_path__ + "static/img/service-whatsapp.bff4f8be.png";